/* "How did you hear about us?" — one vocabulary for the whole portal.

   Mirrors HEARD_ABOUT_OPTIONS and HEARD_ABOUT_LABELS in
   backend/website_engagement.py, which is the same list the public website's
   event signups already answer with. A lead that arrives as an event signup and
   a lead that arrives as an application have to be countable together, so there
   is one list of sources and not one per form.

   Codes are canonical, labels are produced only for display: a code survives a
   round trip through a select element and a label does not. */

export const HEARD_ABOUT_AGENCY = 'agency';

export const HEARD_ABOUT_OPTIONS = [
  { value: 'google', label: 'Google / search' },
  { value: 'social_media', label: 'Social media' },
  { value: 'friend_or_family', label: 'Friend or family' },
  { value: HEARD_ABOUT_AGENCY, label: 'Agency' },
  { value: 'event', label: 'Event or fair' },
  { value: 'other', label: 'Other' },
];

const LABELS = HEARD_ABOUT_OPTIONS.reduce(
  (labels, option) => ({ ...labels, [option.value]: option.label }),
  {},
);

/* The label for a stored source code. An unknown code is shown as itself
   rather than swallowed — the server only ever stores a known code, so a
   surprise here is worth seeing rather than hiding behind "Not provided". */
export function heardAboutLabel(value) {
  const code = String(value || '').trim();
  if (!code) return '';
  return LABELS[code] || code;
}

/* Read the source answer off either record shape.

   Applications and students store this under the same two field names, so this
   is only here to normalize the empty cases for the table cell. */
export function heardAboutOf(record) {
  const source = record || {};
  return {
    code: String(source.heard_about_us || '').trim(),
    detail: String(source.heard_about_us_detail || '').trim(),
    agentId: String(source.agent_id || '').trim(),
    agencyName: String(source.agency_name || '').trim(),
  };
}

/* What the Source column sorts on: the label people actually read, so the
   sort matches the order of the visible text rather than the code behind it. */
export function heardAboutSortValue(record) {
  const { code, agencyName } = heardAboutOf(record);
  return `${heardAboutLabel(code)} ${agencyName}`.trim();
}

export default { HEARD_ABOUT_OPTIONS, HEARD_ABOUT_AGENCY, heardAboutLabel, heardAboutOf, heardAboutSortValue };
